/*
* about form data and Content-Type header boundary
* https://stackoverflow.com/a/39281156
* */


import {toastr} from "react-redux-toastr";

export default class RestService {

    static postEmptyData(url) {

        return this.customFetch(url);

    }


    static postEmptyDataRes(url) {

        return this.customFetch(url)
            .then(res => {
                if (res.status >= 400) throw new Error(res.statusText)
                return res.json()
            })
    }


    static async postEmptyJsonData(url) {

        return (await this.postEmptyData(url)).json();

    }

    static async postTextData(url) {

        return (await this.postEmptyData(url)).text();

    }

    static async postJSON(url, body) {

        return (await this.customFetch(url, body)).json();

    }

    static customFetch(url, headers = {}, body = "", params = {}) {
        return fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json, text/plain',
                'X-CSRF-Token': RestService.getCsrfToken(),
                'X-Requested-With' : 'XMLHttpRequest', // for backend to mark this request as ajax. @see Yii2 yii\web\ErrorAction
                ...headers
            },
            credentials: 'same-origin',
            // credentials: 'omit', // no cookie
            body: body,
            ...params
        });
    }
    static customFetchRes(url, headers = {}, body = "", params = {}) {
        return fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json, text/plain',
                'X-CSRF-Token': RestService.getCsrfToken(),
                'X-Requested-With' : 'XMLHttpRequest', // for backend to mark this request as ajax. @see Yii2 yii\web\ErrorAction
                ...headers
            },
            credentials: 'same-origin',
            // credentials: 'omit', // no cookie
            body: JSON.stringify(body),
            ...params
        }).then(res => {
            if (res.status >= 400) {
                toastr.error('Error', res.statusText)
                throw new Error(res.statusText)
            }
            return res.json()
        });
    }
    static bodyAsFormData(url, body, headers = {}, params = {}) {
        return this.customFetch(url, headers, body, params);
    }

    static postFormData(url, body) {
        return this.customFetch(url, {'Content-Type': "application/x-www-form-urlencoded"}, body);
    }

    static async postFormDataJSON(url, body) {
        return (await this.customFetch(url, {'Content-Type': "application/x-www-form-urlencoded"}, body)).json();
    }

    static getCsrfToken() {
        if (!RestService.__csrfToken) {
            RestService.setCsrfToken(document.querySelector('meta[name="csrf-token"]').getAttribute("content"))
        }
        return RestService.__csrfToken
    }

    static setCsrfToken(token) {
        if (token) RestService.__csrfToken = token
    }

    static customFetchHeaders = {
        'Process-Data' : false,
        'Cache' : false,
        'Accept': '*/*',
    }

    static __csrfToken = null
}

// TODO temp
window.__RestService = RestService



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/helpers/RestService.js